import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { ProjectSearchColumnFields } from '../gridOptions/project-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';

export class ProjectSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const projectResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.Project);
        super(searchQueryService, projectResourceDictionary, dataSourceOptions);
    }

    get rawTextFilterColumnName(): string {
        return ProjectSearchColumnFields.Name;
    }
}
